<template>
  <div>
    <div class="tabel-bar">
      <div class="tabel-bar-left">
        <el-button
          type="primary"
          :size="$store.state.buttonSize"
          @click="materialmanagePopup()"
          >新增物料</el-button
        >
        <RemoveButton
          type="info"
          @click="handleRemoveAll"
          :disabled="!selectionID.length"
        >批量删除</RemoveButton>
      </div>
      <div class="tabel-bar-right">
        <el-input
          placeholder="请输入内容"
          :size="$store.state.formSize"
          prefix-icon="el-icon-search"
          v-model="keywords"
          @input="search"
        ></el-input>
        <el-tooltip effect="dark" content="刷新列表" placement="bottom">
          <span
            class="el-icon-refresh icon-hover refresh-btn"
            @click="debounceRefresh"
          ></span>
        </el-tooltip>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="materialName" label="物料名称">
        <template slot-scope="scope">
          <el-button type="text" @click="detailShow(scope.row.id)">{{ scope.row.materialName }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="materialType" label="物料类型" align="center">
        <template slot-scope="scope">{{ scope.row.materialType | typeName }}</template>
      </el-table-column>
      <el-table-column prop="merchantName" label="供应商" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="manufacturer" label="生产厂家"> </el-table-column>
      <el-table-column prop="productionBatch" label="生产批次"> </el-table-column>
      <el-table-column prop="productionDate" label="生产日期" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.productionDate">
            {{ scope.row.productionDate | formatDate }}
          </template>
        </template>
      </el-table-column>
      <el-table-column label="保质期" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.shelfLife">
            {{ scope.row.shelfLife }}{{ scope.row.shelfLifeUnit || '' }}
          </template>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="materialmanagePopup(scope.row.id)"
            >编辑</el-button
          >
          <el-button type="text" @click="materialmanageDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      :total="total"
    >
    </pagination>
    <!-- 弹出层 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="materialmanageFormVisible"
      center
      width="80%"
    >
      <AddForm ref="materialForm" @materialmanageFinish="materialmanageFinish" @closePopup="closePopup" />
    </el-dialog>
    <!-- 详细信息 -->
    <el-drawer title="" :visible.sync="drawerDetail" size="50%" :with-header="false">
      <div class="content-detail">
        <h2>
          <i class="el-icon-circle-close" @click="drawerDetail = false"></i>
          <span>物料详细信息</span>
        </h2>
        <el-divider></el-divider>
        <table class="content-detail-table">
          <tr>
            <td class="list-item">物料名称</td>
            <td>{{ detailDate.materialName }}</td>
            <td class="list-item">生产日期</td>
            <td>
              <template v-if="detailDate.productionDate">
                {{ detailDate.productionDate | formatDate }}
              </template>
            </td>
          </tr>
          <tr>
            <td class="list-item">商品条码</td>
            <td>{{ detailDate.barcode }}</td>
            <td class="list-item">生产批次</td>
            <td>{{ detailDate.productionBatch }}</td>
          </tr>
          <tr>
            <td class="list-item">物料类型</td>
            <td>{{ detailDate.materialType | typeName }}</td>
            <td class="list-item">供应商</td>
            <td>{{ detailDate.merchantName }}</td>
          </tr>
          <tr>
            <td class="list-item">保质期</td>
            <td>{{ detailDate.shelfLife ? detailDate.shelfLife + (detailDate.shelfLifeUnit || '') : '' }}</td>
            <td class="list-item">标准号</td>
            <td>{{ detailDate.standardNo }}</td>
          </tr>
          <tr>
            <td class="list-item">备注</td>
            <td>{{ detailDate.remark }}</td>
            <td class="list-item"></td>
            <td></td>
          </tr>
          <tr>
            <td class="list-item">物料图片</td>
            <td colspan="3">
              <el-image
                v-if="detailDate.imgUrl"
                :src="detailDate.imgUrl"
                :preview-src-list="[detailDate.imgUrl]"
                style="width: 120px; height: 120px;"
                fit="contain"
              ></el-image>
            </td>
          </tr>
        </table>

        <!-- ===== 专属属性：按物料类型显示不同信息 ===== -->
        <!-- 农药 -->
        <template v-if="detailDate.materialType === 2">
          <el-divider content-position="center">农药专属属性</el-divider>
          <table class="content-detail-table">
            <tr>
              <td class="list-item">农药登记证号</td>
              <td>{{ detailDate.pesticideRegNo }}</td>
              <td class="list-item">农药生产许可证</td>
              <td>{{ detailDate.pesticideProdLicense }}</td>
            </tr>
            <tr>
              <td class="list-item">毒性</td>
              <td>{{ detailDate.toxicity }}</td>
              <td class="list-item">有效成分</td>
              <td>{{ detailDate.activeIngredient }}</td>
            </tr>
            <tr>
              <td class="list-item">剂型</td>
              <td>{{ detailDate.formulation }}</td>
              <td class="list-item">防治对象</td>
              <td>{{ detailDate.controlTarget }}</td>
            </tr>
            <tr>
              <td class="list-item">安全间隔期</td>
              <td>{{ detailDate.safetyInterval }}</td>
              <td class="list-item"></td>
              <td></td>
            </tr>
          </table>
        </template>

        <!-- 化肥 -->
        <template v-if="detailDate.materialType === 3">
          <el-divider content-position="center">化肥专属属性</el-divider>
          <table class="content-detail-table">
            <tr>
              <td class="list-item">工业产品生产许可证号</td>
              <td>{{ detailDate.industrialProdLicense }}</td>
              <td class="list-item">养分配比</td>
              <td>{{ detailDate.nutrientRatio }}</td>
            </tr>
            <tr>
              <td class="list-item">总养分</td>
              <td>{{ detailDate.totalNutrient }}</td>
              <td class="list-item">肥料类型</td>
              <td>{{ detailDate.fertilizerType }}</td>
            </tr>
            <tr>
              <td class="list-item">氯离子含量</td>
              <td>{{ detailDate.chlorideContent }}</td>
              <td class="list-item"></td>
              <td></td>
            </tr>
          </table>
        </template>

        <!-- 种子 -->
        <template v-if="detailDate.materialType === 1">
          <el-divider content-position="center">种子专属属性</el-divider>
          <table class="content-detail-table">
            <tr>
              <td class="list-item">种子生产经营许可证</td>
              <td>{{ detailDate.seedProdLicense }}</td>
              <td class="list-item">品种审定编号</td>
              <td>{{ detailDate.varietyApprovalNo }}</td>
            </tr>
            <tr>
              <td class="list-item">发芽率</td>
              <td>{{ detailDate.germinationRate }}</td>
              <td class="list-item">净度</td>
              <td>{{ detailDate.purity }}</td>
            </tr>
            <tr>
              <td class="list-item">适宜区域</td>
              <td>{{ detailDate.suitableRegion }}</td>
              <td class="list-item"></td>
              <td></td>
            </tr>
          </table>
        </template>

        <!-- 农膜 -->
        <template v-if="detailDate.materialType === 4">
          <el-divider content-position="center">农膜专属属性</el-divider>
          <table class="content-detail-table">
            <tr>
              <td class="list-item">材质</td>
              <td>{{ detailDate.materialTexture }}</td>
              <td class="list-item">厚度</td>
              <td>{{ detailDate.thickness }}</td>
            </tr>
            <tr>
              <td class="list-item">长宽</td>
              <td>{{ detailDate.sizeDimensions }}</td>
              <td class="list-item">膜类型</td>
              <td>{{ detailDate.filmType }}</td>
            </tr>
            <tr>
              <td class="list-item">耐候期</td>
              <td>{{ detailDate.weatheringPeriod }}</td>
              <td class="list-item"></td>
              <td></td>
            </tr>
          </table>
        </template>

        <!-- 其他 -->
        <template v-if="detailDate.materialType === 0">
          <el-divider content-position="center">其他专属属性</el-divider>
          <table class="content-detail-table">
            <tr>
              <td class="list-item">物料用途</td>
              <td>{{ detailDate.materialUsage }}</td>
              <td class="list-item">材质</td>
              <td>{{ detailDate.materialTexture }}</td>
            </tr>
            <tr>
              <td class="list-item">规格参数</td>
              <td>{{ detailDate.specParams }}</td>
              <td class="list-item">执行标准号</td>
              <td>{{ detailDate.execStandardNo }}</td>
            </tr>
          </table>
        </template>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'throttle-debounce'
import AddForm from './components/AddForm'
import {
  getMaterialmanageDetail,
  getMaterialmanageList,
  delMaterialmanageList,
  deleteMaterialmanageDel
} from '@/api/materialmanage'

export default {
  components: {
    AddForm
  },
  data() {
    return {
      materialmanageFormVisible: false,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      currentID: null,
      detailDate: {},
      drawerDetail: false,
      selectionID: [],
      loading: true,
      tableData: []
    }
  },
  computed: {
    title() {
      return this.currentID ? '编辑物料' : '新增物料'
    }
  },
  created() {
    this.debounceRefresh = debounce(300, this.refresh)
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delMaterialmanageList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getMaterialmanageListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getMaterialmanageListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getMaterialmanageListData()
    },
    // 删除物料
    materialmanageDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteMaterialmanageDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除物料成功')
              this.getMaterialmanageListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 打开表单层
    materialmanagePopup(id) {
      const isAdd = !id
      this.materialmanageFormVisible = true
      if (isAdd) {
        this.isPaneDisabled = true
        this.currentID = null
        this.$nextTick(() => {
          this.$refs.materialForm.materialFormPopup()
        })
      } else {
        this.isPaneDisabled = false
        this.currentID = id
        this.$nextTick(() => {
          this.$refs.materialForm.materialFormPopup(id)
        })
      }
    },
    closePopup() {
      this.materialmanageFormVisible = false
    },
    materialmanageFinish() {
      this.materialmanageFormVisible = false
      this.getMaterialmanageListData()
    },
    // 检索
    search() {
      this.getMaterialmanageListData()
    },
    // 刷新数据表格
    refresh() {
      this.getMaterialmanageListData()
      this.$message.success('数据刷新成功')
    },
    // 详情
    detailShow(id) {
      this.drawerDetail = true
      getMaterialmanageDetail(id).then(res => {
        console.log(res)
        if (res.status === 1) {
          this.detailDate = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取物料列表
    getMaterialmanageListData() {
      this.loading = true
      getMaterialmanageList({
        page: this.page,
        size: this.size,
        keywords: this.keywords
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }

        this.loading = false
      })
    }
  },
  mounted() {
    this.getMaterialmanageListData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    // 物料类型：1:种子、2:农药、3:化肥、4:农膜、0:其它
    typeName(value) {
      const map = { 1: '种子', 2: '农药', 3: '化肥', 4: '农膜', 0: '其它' }
      return map[value] !== undefined ? map[value] : value
    }
  }
}
</script>
